import { FormattedMessage } from 'react-intl'
import { ShareWithGroupsAlert } from './ShareWithGroupsAlert'
import { Link, styled } from '@mui/material'
import { ResourceType } from 'features/common/types'
import { PeopleOutlineOutlined } from '@mui/icons-material'

const PeopleIcon = styled(PeopleOutlineOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary
}))

export function ShareWithGroupsAlertNotAvailable({
  resourceType = ResourceType.Connection
}: {
  resourceType?: ResourceType
}) {
  return (
    <ShareWithGroupsAlert icon={<PeopleIcon />}>
      <FormattedMessage
        id="common.shareDialog.shareWithGroups.info.notAvailable"
        values={{
          resource: resourceType,
          link: (content) => (
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://cartohq.typeform.com/to/TCeTkbBE"
              underline="none"
            >
              {content}
            </Link>
          )
        }}
      />
    </ShareWithGroupsAlert>
  )
}
